// Replacement for next/dist/build/polyfills/polyfill-module.js. Our
// browserslist targets only browsers that already implement every feature
// that file polyfills (Array.prototype.at/flat, Object.fromEntries/hasOwn,
// String.prototype.trimStart/End, Symbol.prototype.description), so shipping
// it adds parse cost and ~12 KiB of legacy JS for no behavior change.
// See webpack alias in next.config.ts.
export {};
